import { t } from 'i18next'
import { IChildPlanFormData } from '../contexts/ChildPlanFormDataContext'
import { IParentFormData } from '../contexts/ParentFormDataContext'
import { formatCAD } from './currencyFormatHelper'

export const childPlanSummary = (
    firstName: string,
    lastName: string,
    planName: string,
    planPremium: number,
    planDuration: string,
    autoEnrollment?: string
) => {
    if (autoEnrollment === 'Yes') {
        autoEnrollment = 'autoEnrollment2'
    } else {
        autoEnrollment = ''
    }

    return `${firstName} ${lastName} - ${planName} (${planDuration}${t(
        autoEnrollment
    )})`
}

export const childPlanChildName = (firstName: string, lastName: string) => {
    return `${firstName} ${lastName}`
}

export const childPlanDOB = (dob: string) => {
    return `${dob}`
}

export const childSchool = (school: string) => {
    return `${school}`
}

export const parentSchoolBoard = (schoolBoard: string) => {
    return `${schoolBoard}`
}

export const childPlanDetails = (
    planName: string,
    planDuration: string,
    autoEnrollment?: string
) => {
    if (autoEnrollment === 'Yes') {
        autoEnrollment = 'autoEnrollment2'
    } else {
        autoEnrollment = ''
    }

    return autoEnrollment == ''
        ? `${planName} (${planDuration})`
        : `${planName} (${planDuration} ${t(autoEnrollment)})`
}

export const childPlanCost = (planPremium: number, language: number) => {
    return isNaN(planPremium)
        ? formatCAD(0, language)
        : formatCAD(planPremium, language)
}

export const setChildSectionTitle = (
    childData: IChildPlanFormData,
    parentFormData: IParentFormData
) => {
    let sectionTitle = 'childInfo'
    if (
        childData.FirstName &&
        childData.LastName &&
        childData.Plan.Primary &&
        childData.Plan.Premium >= 0
    ) {
        sectionTitle = childPlanSummary(
            childData.FirstName,
            childData.LastName,
            childData.Plan.Primary,
            childData.Plan.Premium,
            parentFormData.PlanDuration.DurationText
        )
    }
    return sectionTitle
}

export const setPlanOptionMainText = (planDesc: string, language: number) => {
    if (Number(language) === 0) {
        return planDesc.trim().replace(' Plan', '')
    }

    if (Number(language) === 1) {
        return planDesc.trim().replace('Régime', '')
    }

    return planDesc
}

export const filterPlans = (orgGuid: string, planCode: string) => {
    if (orgGuid !== '' && planCode.slice(0, -1) !== 'SAI-EP') {
        return false
    }

    return true
}
